// extracted by mini-css-extract-plugin
export default {"container":"GenreRender_container__-OnJo","left":"GenreRender_left__SN3ZV","right":"GenreRender_right__2dJMo"};